<template>
    <my-multiselect
        ref="my_multiselect"
        v-model="current_value"
        :options="items"
        :placeholder="label"
        :name="name"
        :clearable="clearable"
        :allow-empty="allowEmpty"
        label="name"
        track-by="id"
        @input="valueUpdated"
    />
</template>

<script>
export default {
    props: {
        allowEmpty: {
            type: Boolean,
            default: true,
        },

        items: {
            type: Array,
            required: false,
        },

        label: {
            type: String,
            required: false,
        },

        name: {
            type: String,
            required: false,
        },

        value: {
            type: [String, Number],
            required: false,
        },

        clearable: {
            type: Boolean,
            required: false,
        },
    },

    data() {
        return {
            current_value: this.value,
            previous_value: this.value
        }
    },

    methods: {
        valueUpdated()  {
            this.$emit('input', this.current_value)

            if(this.previous_value != this.current_value)
            {
                this.$emit('updated')
                this.previous_value = this.current_value
            }
        },

        clearInput() {
            this.$refs.my_multiselect.clearInput();
        },
    }
}
</script>